import { SingletonEditor } from "../ContentManager";

const HomePageAdmin = () => (
  <div>
    <p className="mb-6 text-sm text-slate-500">Hero heading, subheading, background image, badges, buttons and section visibility for the homepage. Save &amp; Publish applies changes to the live site immediately.</p>
    <SingletonEditor type="home" />
  </div>
);

export default HomePageAdmin;
